import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FmsAllComponent} from './home/components/fms-all.component';
import {TemplateLayoutComponent} from './template/components/template-layout/template-layout.component';
import {VendorLayoutComponent} from './vendor/component/layout/vendor-layout/vendor-layout.component';
import {RequestActionLayoutComponent} from './request-action/components/layout/request-action-layout.component';
import {TransactionBookingViewerComponent} from './transaction-booking/components/viewer/transaction-booking-viewer.component';
import {MsalGuard} from '@azure/msal-angular';
import {VendorTemplateLayoutComponent} from './vendor-template/component/layout/vendor-template.layout/vendor-template.layout.component';
import {TransactionBookingLayoutComponent} from './transaction-booking/components/layout/transaction-booking-layout.component';
import {VendorListComponent} from './vendor/component/list/vendor-list.component';
import {TransactionBookingListComponent} from './transaction-booking/components/list/transaction-booking-list.component';
import {FileUploadComponent} from './nav/upload/components/file-upload.component';
import {DashboardComponent} from './dashboard/layout/dashboard/dashboard.component';
import {TransactionsComponent} from './dashboard/layout/transactions/transactions.component';
import {FinanceReportComponent} from './finance-report/layout/finance-report/finance-report.component';
import {CommissionReportComponent} from './finance-report/components/commission-report/commission-report.component';
import {CommissionQueueComponent} from './finance-report/components/commission-queue/commission-queue.component';
import {PaymentQueueComponent} from './finance-report/components/payment-queue/payment-queue.component';
import {TripProfitabilityComponent} from './finance-report/components/trip-profitability/trip-profitability.component';
import {VccDailySummaryReportComponent} from './finance-report/components/vcc-daily-summary-report/vcc-daily-summary-report.component';
import {NoAccessComponent} from './unauthorized-access/component/no-access/no-access.component';
import {HomeLayoutComponent} from './home/components/layout/home-layout.component';
import {UserRoleConstants} from './shared/model/user-role.constants';
import {AuthRoleGuard} from 'src/infrastructure/guards/auth-role.guard';
import {FinanceComponent} from './dashboard-finance/layout/finance/finance.component';
import {TripProfitabilityWithAgencyComponent} from './finance-report/components/trip-profitability-with-agency/trip-profitability-with-agency.component';
import {TraceComponent} from './trace/component/trace.component';
import {InvoicesComponent} from './invoices/layout/invoices/invoices.component';
import {AdxInvoiceLineItemsComponent} from './invoices/component/adx-invoice-line-items/adx-invoice-line-items.component';
import {TramsInvoicesComponent} from './invoices/component/trams-invoices/trams-invoices.component';
import {PaymentsComponent} from './payments/layout/payments/payments.component';
import {AdxVccComponent} from './finance-resource/component/adx-vcc/adx-vcc.component';
import {FmsVccComponent} from './finance-resource/component/fms-vcc/fms-vcc.component';
import {InvoiceDetailComponent} from './invoices/layout/invoice-detail/invoice-detail.component';
import {VccComponent} from './dashboard/layout/vcc/components/vcc.component';
import {VccReportComponent} from './dashboard/layout/vcc/components/vcc-report/vcc-report.component';
import {MatchingVccComponent} from './finance-resource/component/matching-vcc/matching-vcc.component';
import {MatchingVccV2Component} from './finance-resource/component/matching-vcc-v2/matching-vcc-v2.component';
import {MatchingVccDetailComponent} from './finance-resource/component/matching-vcc-detail/matching-vcc-detail.component';
import {AlertsGridComponent} from './finance-resource/component/alerts/alerts.component';
import {CommissionRulesGridComponent} from './commission-rules/component/commission-rules-grid/commission-rules-grid.component';
import {TripListComponent} from './trip/components/trip-list/trip-list.component';
import {TripDetailsComponent} from './trip/components/trip-details/trip-details.component';
import {AdxInvoiceDetailsComponent} from './adx-invoice/components/adx-invoice-details/adx-invoice-details.component';
import {ClientListComponent} from './client/component/list/client-list.component';
import {AgentListComponent} from './agent/component/list/agent-list.component';
import {TramsInvoiceComponent} from './invoices/component/layout/trams-invoice.component';
import {unsavedChangesGuard} from 'src/infrastructure/guards/unsaved-changes.guard';
import {HsProcessingComponent} from './trx-team-resource/components/hs-processing/hs-processing.component';
import {AdxBookingDetailsComponent} from './adx-booking/components/adx-booking-details/adx-booking-details.component';
import {PaymentsReceivedGridComponent} from './payments/components/payments-received-grid/payments-received-grid.component';
import {PaymentsMadeGridComponent} from './payments/components/payments-made-grid/payments-made-grid.component';
import {AdxPaymentDetailsComponent} from './adx-payment/components/adx-payment-details/adx-payment-details.component';
import {GeneralLedgerComponent} from './general-ledger/layout/general-ledger.component';
import {ChartOfAccountsComponent} from './general-ledger/components/chart-of-accounts/chart-of-accounts.component';
import {ClientBalanceComponent} from './balances/components/client-balance/client-balance.component';
import {VendorBalanceComponent} from './balances/components/vendor-balance/vendor-balance.component';
import {ArcBspBalanceComponent} from './balances/components/arc-bsp-balance/arc-bsp-balance.component';
import {GLTravelTypeMappingComponent} from './general-ledger/components/travel-type-mapping/travel-type-mapping.component';
import {FmsInvoiceComponent} from './fms-invoice/component/fms-invoice.component';
import {GLClosePeriodComponent} from './general-ledger/components/close-period/close-period.component';
import {TripReferenceDetailsComponent} from './finance-resource/component/trip-reference-details/trip-reference-details.component';
import {TransactionHistoryDetailsComponent} from './finance-resource/component/transaction-history-details/transaction-history-details.component';
import {VendorViewerComponent} from './vendor/component/viewer/vendor-viewer/vendor-viewer.component';
import {BraintreeMatchingVccComponent} from './finance-resource/component/braintree-matching-vcc/braintree-matching-vcc.component';
import {NavExportComponent} from './general-ledger/components/nav-export/nav-export.component';
import {AirMatchingReportComponent} from './finance-resource/component/air-matching-report/air-matching-report.component';
import {AgentDetailsComponent} from './agent/component/details/agent-details.component';
import {SplitRateDetailsComponent} from './agent/component/split-rate-details/split-rate-details.component';
import {BalancesComponent} from './balances/layout/balances/balances.component';
import {CommissionReconciliationComponent} from './payments/components/commission-reconciliation/commission-reconciliation.component';
import {VendorStatementComponent} from './balances/components/vendor-statement/vendor-statement.component';
import {TripLayoutComponent} from "./trip/trip-layout/trip-layout.component";
import {TramsTripComponent} from "./trip/components/trams-trip/trams-trip.component";
import {ClientStatementComponent} from './statements/components/client-statement/client-statement.component';
import {financeResolver} from "./dashboard-finance/resolvers/finance.resolver";
import { ReconciliationPaymentsComponent } from './payments/components/reconciliation/reconciliation-payments-component/reconciliation-payments-component.component';
import {
  MatchingVccPaymentDetailReportComponent
} from "./finance-resource/component/matching-vcc-payment-detail-report/matching-vcc-payment-detail-report.component";
import {
  matchingVccPaymentDetailReportResolver
} from "./finance-resource/resolvers/matching-vcc-payment-detail-report.resolver";
import {FmsInvoicesComponent} from "./invoices/component/fms-invoices/fms-invoices.component";
import {AdminPanelComponent} from "./dashboard-finance/layout/admin-panel/admin-panel.component";
import {AdxErpPanelComponent} from "./dashboard-finance/adx-erp-panel/layout/adx-erp-panel.component";
import {TmtErpPanelComponent} from "./dashboard-finance/tmt-erp-panel/layout/tmt-erp-panel.component";
import {ErpOutboundPanelComponent} from "./dashboard-finance/erp-outbound-panel/layout/erp-outbound-panel.component";
import {TmtErpOutboundPanelComponent} from "./dashboard-finance/tmt-erp-outbound-panel/layout/tmt-erp-outbound-panel.component";
import {AdxSbReconciliationComponent} from "./dashboard-finance/adx-sb-reconciliation/layout/adx-sb-reconciliation.component";
import {PlaygroundListComponent} from './playground/components/playground-list/playground-list.component';
import {PlaygroundSalesOrderComponent} from './playground/components/playground-sales-order/playground-sales-order.component';
import {KtTripsComponent} from './kt-trips/layout/kt-trips.component';
import {KtTripDetailComponent} from './kt-trips/layout/kt-trip-detail.component';
import {KtServicesComponent} from './kt-trips/layout/kt-services.component';
import {KtServiceDetailComponent} from './kt-trips/layout/kt-service-detail.component';
import {KtPaymentsComponent} from './kt-trips/layout/kt-payments.component';
import {KtPaymentDetailComponent} from './kt-trips/layout/kt-payment-detail.component';
import {KtCogsComponent} from './kt-trips/layout/kt-cogs.component';
import {KtCogsDetailComponent} from './kt-trips/layout/kt-cogs-detail.component';
import {DocGuideComponent} from './documentation/components/doc-guide/doc-guide.component';
import {DBOV2_PAYLOAD_GUIDE_MARKDOWN} from './documentation/content/dbov2-payload-guide.content';
import {DBOV2_ERP_MAPPING_GUIDE_MARKDOWN} from './documentation/content/dbov2-erp-mapping-guide.content';
import {DBOV2_ERP_PUSH_EXAMPLE_MARKDOWN} from './documentation/content/dbov2-erp-push-example.content';
import {FMS_UI_TRAINING_GUIDE_MARKDOWN} from './documentation/content/fms-ui-training-guide.content';
import {TMT_MODEL_GUIDE_MARKDOWN} from './documentation/content/tmt-model-guide.content';
import {TMT_ERP_MAPPING_GUIDE_MARKDOWN} from './documentation/content/tmt-erp-mapping-guide.content';

const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
  },
  {
    path: 'trace',
    component: TraceComponent,
    canActivate: [MsalGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    }
  },
  {
    path: 'Actions',
    component: FmsAllComponent,
    canActivate: [MsalGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    }
  },
  {
    path: 'Clients',
    component: ClientListComponent
  },
  {
    path: 'Agents',
    component: AgentListComponent
  },
  {
    path: 'Dashboard',
    component: DashboardComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Director
      ]
    },
    children: [
      {
        path: 'Transactions',
        component: TransactionsComponent
      },
      {
        path: 'Finance',
        component: FinanceComponent,
        resolve: { data: financeResolver }
      },
      {
        path: 'Vcc',
        component: VccComponent
      },
      {
        path: 'VccReport',
        component: VccReportComponent
      },
      {
        path: 'AdminPanel',
        component: AdminPanelComponent
      },
      {
        path: 'AdxErpPanel',
        component: AdxErpPanelComponent
      },
      {
        path: 'TmtErpPanel',
        component: TmtErpPanelComponent
      },
      {
        path: 'ErpOutboundPanel',
        component: ErpOutboundPanelComponent
      },
      {
        path: 'TmtErpOutboundPanel',
        component: TmtErpOutboundPanelComponent
      },
      {
        path: 'AdxSbReconciliation',
        component: AdxSbReconciliationComponent
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Transactions'
      }
    ]
  },
  {
    path: 'FinanceReports',
    component: FinanceReportComponent,
    children: [
      {
        path: 'CommissionReports',
        component: CommissionReportComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'CommissionQueue',
        component: CommissionQueueComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'PaymentQueue',
        component: PaymentQueueComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'TripProfitability',
        component: TripProfitabilityComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'TripProfitabilityWithAgency',
        component: TripProfitabilityWithAgencyComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Director
          ]
        },
      },
      {
        path: 'VccDailySummaryReport',
        component: VccDailySummaryReportComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'CommissionReports'
      }
    ]
  },
  {
    path: 'NoAccess',
    component: NoAccessComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'VendorSearch',
    component: VendorLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Vendors',
    component: VendorListComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Templates',
    component: VendorTemplateLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Rules',
    component: TemplateLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'RequestAction/:id', component: RequestActionLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'RequestAction',
    component: RequestActionLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Services',
    component: TransactionBookingListComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'BookingsSearch',
    component: TransactionBookingLayoutComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Services/:id',
    component: TransactionBookingViewerComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'FileUpload',
    component: FileUploadComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Invoices',
    component: InvoicesComponent,
    children: [
      {
        path: 'AdxInvoiceLineItems',
        component: AdxInvoiceLineItemsComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'TramsInvoices',
        component: TramsInvoicesComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'FmsInvoices',
        component: FmsInvoicesComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'AdxInvoices'
      }
    ]
  },
  {
    path: 'Invoices/TramsInvoices/:invoiceId',
    component: TramsInvoiceComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'AdxInvoices/:id',
    component: AdxInvoiceDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Itinerary/:invoiceLineItemId',
    component: InvoiceDetailComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Payments',
    component: PaymentsComponent,
    children: [
      {
        path: 'Received',
        component: PaymentsReceivedGridComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'Made',
        component: PaymentsMadeGridComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'PaymentsReconciliation',
        component: ReconciliationPaymentsComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.User
          ]
        },
      },
      {
        path: 'CommissionReconciliation',
        component: CommissionReconciliationComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'Received'
      }
    ]
  },
  {
    path: 'Balances',
    component: BalancesComponent,
    children: [
      {
        path: 'ClientBalance',
        component: ClientBalanceComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'VendorBalance',
        component: VendorBalanceComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
      {
        path: 'ArcBspBalance',
        component: ArcBspBalanceComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance
          ]
        },
      },
    ]
  },
  {
    path: 'FinanceResources',
    component: PaymentsComponent,
    children: [
      {
        path: 'AdxVcc',
        component: AdxVccComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'AdxVcc/:cardGuid',
        component: AdxVccComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'FmsVcc',
        component: FmsVccComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'MatchingVcc',
        component: MatchingVccComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        canDeactivate: [unsavedChangesGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'MatchingVccPaymentDetail/:id',
        component: MatchingVccPaymentDetailReportComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
        resolve: {data: matchingVccPaymentDetailReportResolver}
      },
      {
        path: 'ConnexpayVccMatchingReport',
        component: MatchingVccV2Component,
        canActivate: [MsalGuard, AuthRoleGuard],
        canDeactivate: [unsavedChangesGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'MatchingVcc/:id',
        component: MatchingVccDetailComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'ConnexpayVccMatchingReport/:id',
        component: MatchingVccDetailComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'BraintreeVccMatchingReport',
        component: BraintreeMatchingVccComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        canDeactivate: [unsavedChangesGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'MorAirMatchingReport',
        component: AirMatchingReportComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        canDeactivate: [unsavedChangesGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager
          ]
        },
      },
      {
        path: 'Alerts',
        component: AlertsGridComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Manager,
            UserRoleConstants.Director
          ]
        },
      },
      {
        path: 'CommissionRules',
        component: CommissionRulesGridComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Manager,
            UserRoleConstants.Finance,
            UserRoleConstants.Director
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'AdxVcc'
      }
    ]
  },
  {
    path: 'Trips',
    component: TripLayoutComponent,
    children: [
      {
        path: 'FmsTrips',
        component: TripListComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.User
          ]
        }
      },
      {
        path: 'FmsTramsTrips',
        component: TramsTripComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.User
          ]
        }
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'FmsTrips'
      }
    ]
  },
  {
    path: 'Trip/:id',
    component: TripDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    }
  },
  {
    path: 'AdxBookings/:id',
    component: AdxBookingDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'AdxPayments/:id',
    component: AdxPaymentDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'TstResources',
    component: HsProcessingComponent,
    children: [
      {
        path: 'HsProcessing',
        component: HsProcessingComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.User
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'HsProcessing'
      }
    ]
  },
  {
    path: 'GeneralLedger',
    component: GeneralLedgerComponent,
    children: [
      {
        path: 'ChartOfAccounts',
        component: ChartOfAccountsComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager,
          ]
        },
      },
      {
        path: 'TravelTypeMapping',
        component: GLTravelTypeMappingComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager,
          ]
        },
      },
      {
        path: 'NavExport',
        component: NavExportComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Finance,
            UserRoleConstants.Manager,
          ]
        },
      },
      {
        path: 'ClosePeriod',
        component: GLClosePeriodComponent,
        canActivate: [MsalGuard, AuthRoleGuard],
        data: {
          roles: [
            UserRoleConstants.Director
          ]
        },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'ChartOfAccounts'
      }
    ],
  },
  {
    path: 'fmsinvoice/:id',
    redirectTo: 'FmsInvoice/:id',
    pathMatch: 'full',
  },
  {
    path: 'FmsInvoice/:id',
    component: FmsInvoiceComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'TripReference/TravelService/:travelServiceId',
    component: TripReferenceDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'TransactionHistory/:guid',
    component: TransactionHistoryDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Vendor/CentralDocument/:tramsCentralDocumentId',
    component: VendorViewerComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Agents/:agentId',
    component: AgentDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Agents/:agentId/SplitRate',
    component: SplitRateDetailsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Clients/:clientId/Statements',
    component: ClientStatementComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Vendors/:vendorId/Statements',
    component: VendorStatementComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.Finance
      ]
    },
  },
  {
    path: 'Playground',
    component: PlaygroundListComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Playground/:id',
    component: PlaygroundSalesOrderComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtTrips',
    component: KtTripsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtTrip/:id',
    component: KtTripDetailComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtServices',
    component: KtServicesComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtService/:id',
    component: KtServiceDetailComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtTravelerPayments',
    component: KtPaymentsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtTravelerPayment/:id',
    component: KtPaymentDetailComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtCogs',
    component: KtCogsComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'KtCogs/:id',
    component: KtCogsDetailComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User
      ]
    },
  },
  {
    path: 'Documentation/FmsUiGuide',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'FMS Admin Panel — How to Use This UI',
      subtitle: 'A training-style walkthrough covering roles, filters, trips, invoices, booking details (agents/UDID/segments), dashboards, and how Agent/Client/Vendor data is synced into FMS.',
      content: FMS_UI_TRAINING_GUIDE_MARKDOWN
    },
  },
  {
    path: 'Documentation/DboV2PayloadGuide',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'DBOv2 Invoice Payload — Application Guide',
      subtitle: 'How to publish invoices into FMS DBOv2 over Service Bus: payload fields, mandatory/optional rules, enums and validation.',
      content: DBOV2_PAYLOAD_GUIDE_MARKDOWN
    },
  },
  {
    path: 'Documentation/ErpMappingGuide',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'DBOv2 → ERP/D365 Field Mapping Guide',
      subtitle: 'What fms-erp-api reads off a DBOv2 invoice to build and push the D365 XML, so a new invoice source knows which fields matter end-to-end.',
      content: DBOV2_ERP_MAPPING_GUIDE_MARKDOWN
    },
  },
  {
    path: 'Documentation/ErpPushExample',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'Practical Example — Minimum Payload for a Successful ERP Push',
      subtitle: 'A worked example payload, plus a per-service-type checklist (Hotel ChainCode, Air segments, Cruise commission, Transfer itinerary, and more) covering everything that must be present in the invoice, and already set up in FMS, for it to reach D365 successfully.',
      content: DBOV2_ERP_PUSH_EXAMPLE_MARKDOWN
    },
  },
  {
    path: 'Documentation/TmtModelGuide',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'TMT — Data Model & How Data Is Pulled Into FMS',
      subtitle: 'What a TMT Sales Order is, how it is copied from TMT into fms-tmt-sql, queued, and eventually pushed to the D365 ERP outbound pipeline — the TMT equivalent of the DBOv2 payload guide.',
      content: TMT_MODEL_GUIDE_MARKDOWN
    },
  },
  {
    path: 'Documentation/TmtErpMappingGuide',
    component: DocGuideComponent,
    canActivate: [MsalGuard, AuthRoleGuard],
    data: {
      roles: [
        UserRoleConstants.User,
        UserRoleConstants.Manager,
        UserRoleConstants.Finance,
        UserRoleConstants.Director
      ],
      title: 'TMT Sales Order → ERP/D365 Field Mapping Guide',
      subtitle: 'What fms-erp-api reads off a TMT Sales Order to resolve customer/vendor/worker accounts and build the D365 message — and which missing pieces hard-fail versus silently fall back to a placeholder.',
      content: TMT_ERP_MAPPING_GUIDE_MARKDOWN
    },
  },
  {
    path: '**',
    redirectTo: '/'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
